// コレクションの切り替え
$(function(){
  $("#js-button-popular").click(function(e){
    const sortButton = document.querySelector('[data-sort="best-selling"]');
    $(".collection-common__button").removeClass("is-current")
    $("#js-button-popular").addClass("is-current")
    $(sortButton).trigger("click")
  })
  $("#js-button-new").click(function(e){
    const sortButton = document.querySelector('[data-sort="created-descending"]');
    $(".collection-common__button").removeClass("is-current")
    $("#js-button-new").addClass("is-current")
    $(sortButton).trigger("click")
  })
  $("#js-button-cheap").click(function(e){
    const sortButton = document.querySelector('[data-sort="price-ascending"]');
    $(".collection-common__button").removeClass("is-current")
    $("#js-button-cheap").addClass("is-current")
    $(sortButton).trigger("click")
  })
  $("#js-button-expensive").click(function(e){
    const sortButton = document.querySelector('[data-sort="price-descending"]');
    $(".collection-common__button").removeClass("is-current")
    $("#js-button-expensive").addClass("is-current")
    $(sortButton).trigger("click")
  })
})
